import React from "react";
import Dialog from "@material-ui/core/Dialog";
import styled from "styled-components";

const AlertDialog = ({
  heading = "Quit Case",
  desc = "Are you sure you want to Quit this case? All the negotiation progress will be lost if you quit case at this point",
  secondaryBtnText = "Close",
  primaryBtnText,
  clickSecondarybtn = () => {},
  clickPrimaryBtn = () => {},
  isOpen = false,
  onDialogClose = () => {},
}) => {
  return (
    <StyledDialog
      open={isOpen}
      onClose={onDialogClose}
      disableRestoreFocus={true}
      disableScrollLock={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <IconWrapper>
          <WarningIcon>{"⚠"}</WarningIcon>
        </IconWrapper>

        <Heading>{heading}</Heading>
        <Description>{desc}</Description>

        <ButtonWrapper>
          <SecondaryButton onClick={clickSecondarybtn}>
            {secondaryBtnText}
          </SecondaryButton>
        </ButtonWrapper>
      </DialogContent>
    </StyledDialog>
  );
};

export default AlertDialog;

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 16px;
    max-width: 590px;
    width: 90%;
    margin: 16px;
    box-shadow:
      0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04);

    @media (min-width: 768px) {
      width: 100%;
    }
  }
`;

const DialogContent = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(251, 191, 36, 0.2);
`;

const WarningIcon = styled.span`
  font-size: 32px;
  font-weight: bold;
  color: #92400e;
`;

const Heading = styled.h2`
  font-family: openSans-Bold, sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #293461;
  margin: 0 0 12px 0;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 22px;
  }
`;

const Description = styled.p`
  font-family: openSans-Regular, sans-serif;
  font-size: 14px;
  color: #293461;
  text-align: center;
  margin: 0 0 24px 0;
  line-height: 1.6;

  @media (min-width: 768px) {
    font-size: 15px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  flex-direction: column-reverse;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
  }
`;

const BaseButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  font-family: "openSans-SemiBold", sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  outline: none;
  flex: 1;
  max-width: 180px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  @media (max-width: 767px) {
    max-width: 100%;
  }
`;

export const PrimaryButton = styled(BaseButton)`
  background-color: #d91b1b;
  color: white;
  border: 1px solid #d91b1b;
  box-shadow: 0 1px 2px rgba(0, 131, 140, 0.1);

  &:hover:not(:disabled) {
    background-color: #d91b1b;
    box-shadow: 0 4px 12px rgba(0, 131, 140, 0.2);
  }
`;

export const SecondaryButton = styled(BaseButton)`
  background-color: #00838c;
  color: #ffffff;
  border: 1.5px solid #00838c;

  &:hover:not(:disabled) {
    background-color: #00838c;
    border-color: #00838c;
  }
`;
